import "./SeeProjectButton.scss";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const SeeProjectButton = ({
  label,
  onClick,
  href,
  variant = "default",
  disabled = false,
}) => {
  if (href) {
    // If href starts with "/", use Link from React Router for internal navigation
    if (href.startsWith("/")) {
      return (
        <Link
          to={href} // Use to prop from Link component
          className={`see-project-button ${variant} ${disabled ? "disabled" : ""}`}
          onClick={disabled ? (e) => e.preventDefault() : undefined}
        >
          {label}
        </Link>
      );
    }

  }

  return (
    <button
      className={`see-project-button ${variant} ${disabled ? "disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default SeeProjectButton;
